import type { ListTasksResponse } from '@bliks-io/contracts';
import { countTasks } from '@/api/queries/useTasks';
import { QueryErrorRetry } from '@/components/query-error-retry/QueryErrorRetry';
import { AllDoneBanner } from './AllDoneBanner';
import { EmptyTasksState } from './EmptyTasksState';
import { MyTasksSkeleton } from './MyTasksSkeleton';

interface TaskListStatusProps {
  tasks: ListTasksResponse | undefined;
  isLoading: boolean;
  isError: boolean;
  isFetching: boolean;
  onRetry: () => void;
}

/** What My Tasks shows in place of its task tables: loading, a failed load, or nothing to do. */
export function TaskListStatus({
  tasks,
  isLoading,
  isError,
  isFetching,
  onRetry
}: TaskListStatusProps) {
  if (isLoading) return <MyTasksSkeleton />;

  if (isError && !tasks) {
    return <QueryErrorRetry onRetry={onRetry} loading={isFetching} className="h-64" />;
  }

  if (tasks && countTasks(tasks) === 0) {
    return (
      <>
        <AllDoneBanner />
        <EmptyTasksState />
      </>
    );
  }

  return null;
}
